import React from "react";
import ChatTimer from "./ChatTimer";
import moment from "moment";

function ChatStatus(data) {
  const chatStatus = (data) => {
    if (data.checkChatSession) {
      return (
        <div className="row no-gutters">
          <div className="chat-time">
            {" "}
            {moment(new Date(data.chat.end_at * 1000)).format(
              "DD MMM YYYY"
            )} •{" "}
          </div>
          <div className="chat-status">Session Ended</div>
        </div>
      );
    } else {
      let remainingTime =
        (data.chat.end_at - data.chat.server_current_time) * 1000;
      if (remainingTime > 0) {
        if (!data.chat.hasStarted) {
          return (
            <div className="chat-time">
              <div className="chat-status upcoming">
                Session starts in{" "}
                {moment(new Date(data.chat.start_at * 1000)).fromNow()}
              </div>{" "}
            </div>
          );
        }
        return (
          <div className="row no-gutters">
            <div className="chat-time" style={{ color: "#FF6F61" }}>
              {" "}
              {moment(new Date(data.chat.end_at * 1000)).format(
                "DD MMM YYYY"
              )}{" "}
              •{" "}
            </div>
            <div className="chat-status badge">
              <ChatTimer remainingTime={remainingTime} className="time" />
            </div>
          </div>
        );
      } else if (data.chat.open_session) {
        return null;
      } else return <div className="chat-status badge">Session Ended</div>;
    }
  };

  return chatStatus(data);
}

export default ChatStatus;
